<template>
    <div class="ivu-shrinkable-menu left-bj">
        <div v-for="modular in menuList">
            <div id="user-left-box" class="clearfix" v-show="!shrink">
                <div class="user-box">
                    <span class="name">{{modular.title}}</span>
                </div>
            </div>
            <SidebarMenu 
                v-show="!shrink"
                :menu-theme="theme" 
                :menu-list="modular.menuList" 
                @on-change="handleChange"
            ></SidebarMenu>
            <SidebarMenuShrink 
                v-show="shrink"
                :menu-theme="theme" 
                :menu-list="modular.menuList" 
                :icon-color="shrinkIconColor"
                @on-change="handleChange"
            ></SidebarMenuShrink>
        </div>
    </div>
</template>

<script>
import SidebarMenu from './SidebarMenu.vue';
import SidebarMenuShrink from './SidebarMenuShrink.vue';
export default {
    name: 'shrinkableMenu',
    components: {
        SidebarMenu,
        SidebarMenuShrink
    },
    props: {
        //收缩
        shrink: {
            type: Boolean,
            default: false
        },
        //菜单
        menuList: {
            type: Array,
            required: true
        },
        //主题
        theme: {
            type: String,
            default: 'dark',
        },
    },
    computed: {
        //背景色
        bgColor () {
            return this.theme === 'dark' ? '#3C4454' : '#586E8F';
        },
        //图标颜色
        shrinkIconColor () {
            return this.theme === 'dark' ? '#586E8F' : '#3C4454';
        }
    },
    mounted(){
        
            
    },
    methods: {
        //切换菜单
        handleChange (name) {
            this.$router.push({
                name: name
            });
        }
    }
};
</script>
<style lang="less" >
    @import "./shrinkableMenu.less";
</style>


// WEBPACK FOOTER //
// src/pages/layout/business/ShrinkableMenu.vue